import ITableDataFetcher from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataFetcher';
import {
    SlimUser,
    OrderBy,
    Filter,
    GetAllUsersByFilterModel,

} from 'Core/Api/Api';
import TableRequest from 'Core/TableUtility/Models/TableRequest';
import ITableDataResponse from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataResponse';
import { SecuredClient } from 'Core/Api/SecuredClient';
import Utility from 'Core/Utility';

export default class JcsdAccountHandler implements ITableDataFetcher<SlimUser> {
    constructor(props?: any) { }

    GetData(tableRequest: TableRequest): Promise<ITableDataResponse<SlimUser>> {
        return this.GetOfferings();
    }


    GetOfferings() {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetAllUsersByFilterModel();
        request.amountPerPage = 500;
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getAllUsersByFilter(request);
    }

}













